var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "master-filter app-filter hideSmartphone"
  }, [_c('div', {
    staticClass: "app-filter-label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "app-filter-select"
  }, [_c('b-dropdown', {
    ref: "dropdown-filters",
    attrs: {
      "variant": "link",
      "toggle-class": "app-filter-toggle",
      "menu-class": "app-filter-menu",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "app-filter-trigger"
        }, [_c('span', [_vm._v(_vm._s(_vm.inspectionsFor.active.name))]), _c('svg', {
          attrs: {
            "width": "14",
            "height": "14",
            "viewBox": "0 0 20 20",
            "fill": "none",
            "aria-hidden": "true"
          }
        }, [_c('path', {
          attrs: {
            "d": "M5 7.5L10 12.5L15 7.5",
            "stroke": "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })])])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.inspectionsFor.inDropdown, function (item, key) {
    return _c('b-dropdown-item', {
      key: key,
      staticClass: "app-filter-item",
      "class": {
        'active-filter': _vm.inspectionsFor.active.value === item.value
      },
      attrs: {
        "link-class": "app-filter-option-link",
        "href": "#"
      },
      on: {
        "click": function click($event) {
          return _vm.filterPeriod(item);
        }
      }
    }, [_c('div', {
      staticClass: "app-filter-option"
    }, [_c('span', {
      staticClass: "app-filter-option-label"
    }, [_vm._v(_vm._s(item.name))]), _vm.inspectionsFor.active.value === item.value ? _c('span', {
      staticClass: "app-filter-check"
    }, [_vm._v("✓")]) : _vm._e()])]);
  }), 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }